<template>
  <div
    class="advance-swiper"
    :style="{ backgroundImage: $attrs.backgroundImage ? `url(${$attrs.backgroundImage})` : '' }"
  >
    <div class="content">
      <div
        class="mobile-main-title"
        v-if="mainTitle.title"
        :style="transfCss.mainTitle"
      >{{ mainTitle.title }}</div>
      <swiper
        ref="mySwiper"
        :options="swiperOptions"
        :style="{ padding: transfCss.padding }"
      >
        <swiper-slide
          v-for="(item, index) in $attrs.imgList"
          :key="index"
        >
          <div class="resource">
            <template v-if="verifySuffix(item) === 'image'">
              <img
                class="img-item"
                :src="item.url"
                @click.prevent.stop="mode ? openUrl(item.link) : handleClickItem(index, 4, $event)"
                :style="{
                  height: item.height ? item.height + 'px' : undefined
                }"
              />
            </template>
            <template v-if="verifySuffix(item) === 'video'">
              <video
                class="img-item"
                :src="item.url"
                controls
                :height="item.height"
              />
            </template>
            <img
              v-if="arrow.show && $attrs.imgList.length !== (index + 1)"
              class="item-arrow"
              :src="arrow.url ? arrow.url : arrowImgUrl"
              :style="transfCss.arrow"
            />
          </div>
          <div
            class="mobile-bottom-title"
            v-if="item.bottomTitle.show"
            :style="transfCssUtil(item.bottomTitle)"
          >{{ item.bottomTitle.desc }}</div>
        </swiper-slide>
        <div
          class="swiper-button-prev swiper-button"
          slot="button-prev"
        ></div>
        <div
          class="swiper-button-next swiper-button"
          slot="button-next"
        ></div>
      </swiper>
    </div>
  </div>
</template>
<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import merge from 'lodash/merge'
import { transfCssUtil } from '../../utils/index'
import mixin from '../../utils/mixin'
export default {
  props: ['option'],
  mixins: [mixin],
  data () {
    return {
      swiperOptions: {},
      arrowImgUrl: require('../../image/arrow.png'),
      transfCssUtil
    }
  },
  computed: {
    transfCss () {
      const { arrow, mainTitle, padding } = this.$attrs
      return this.transfCssUtil({
        arrow,
        mainTitle,
        padding
      })
    },
    swiper () {
      return this.$refs.mySwiper.swiper
    },
    mainTitle () {
      return this.$attrs.mainTitle
    },
    arrow () {
      return this.$attrs.arrow || {}
    }
  },
  created () {
    this.initOptions()
  },
  methods: {
    initOptions () {
      this.swiperOptions = merge({
        slidesPerColumnFill: 'column',
        direction: 'horizontal',
        autoplayDisableOnInteraction: false,
        observer: true,
        observeParents: true,
        grabCursor: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          disabledClass: 'my-button-disabled',
        },
        breakpoints: {
          1024: {
            slidesPerView: 3,
            spaceBetween: 0,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 0,
          },
          480: {
            slidesPerView: 1,
            spaceBetween: 0,
          }
        }
      }, this.option)
    },
    verifySuffix (item) {
      const imglist = `(png|jpg|jpeg|bmp|gif|webp)`
      const videoList = `mp4|m2v|mkv|webm`

      if (new RegExp(`.*\.${imglist}`).test(item.url)) {
        return 'image'
      } else if (new RegExp(`.*\.${videoList}`).test(item.url)) {
        return 'video'
      }
    }
  },
  watch: {
    option (val) {
      this.$nextTick(() => {
        if (this.swiper) {
          this.swiper.params = merge(this.swiper.params, val)
          this.swiper.update()
        }
      })
    }
  },
  components: {
    swiper,
    swiperSlide
  }
}
</script>
<style lang="stylus" scoped>
.advance-swiper
  background-repeat no-repeat
  background-size cover
  .content
    max-width 1200px
    margin 0 auto
  .resource
    display flex
    align-items center
    .img-item
      flex 1
      width 100%
  .swiper-button
    width 30px
    height 30px
    color #3A6FFF
    background-color rgba(255, 255, 255, 0.9)
    background-size 15px 15px
    border-radius 50%
  .my-button-disabled
    display none
</style>
<style lang="stylus" scoped>
@media screen and (max-width 1024px)
  .item-arrow
    display none
</style>
